

// this.tableResult 

export const filters = {
  "Voorraad > 0": prod => prod.currentStock > 0,
  "Voorraad <= 7d verkocht": prod => prod.currentStock < prod.orders_7d,
  "Voorraad <= 1M verkocht": prod => prod.currentStock < prod.orders_1m,
  "Geen Voorraad": prod => prod.currentStock <= 0,
  "7d verkoop > 0": prod => prod.orders_7d > 0,
  "1M verkoop > 0": prod => prod.orders_1m > 0,
  "1Y verkoop > 0": prod => prod.orders_1y > 0,
  "Merk Leeg": prod => !prod.brand,
  "Leverancier Leeg": (prod, vm) => !vm.productSettings[prod.id] || !vm.productSettings[prod.id].supplier,
  "Stop bijbestellen": (prod, vm) => vm.productSettings[prod.id] && vm.productSettings[prod.id].stopped,
  "Geen Engine advies": prod => prod.engine.value === 'N/A',
  "Bestellen = 0": (prod, vm) => {
    if (vm.productOrderOverride[prod.id].amount) {
      return vm.productOrderOverride[prod.id].amount == 0
    }
    return prod.engine.value == 0
  },
}